
  $('.trigger-source').click(function(event){
    event.preventDefault();
     
    var $trigger = $(this);
    var $howmanysource = $('.product-form__source').size();

    if ( $('.product-form__source-container').hasClass('is-active')) {
      var $triggersourceparent = $(this).parents('.product-form__source');
      var $val = $trigger.text();

      $triggersourceparent.attr('data-source_ans', $val);

      $triggersourceparent.find('.qq').hide();

      if ( $val == "Yes" ) {
        $triggersourceparent.find('.kit').show();
        $triggersourceparent.find('.source').hide();



        $triggersourceparent.find( ".collectionkit-trigger-complete" ).keyup(function() {
         // alert('testtsdsd');
          if ( $(this).val() != '' ) {
            $triggersourceparent.addClass('sourceis-complete');
            if ( condtionsource() == $howmanysource ) {
              $('.product-form__cart-submit').removeAttr("disabled");
              $('.product-form__cart-submit').attr("title","Add to cart");
            }
            /* Engrave Condition */
            $triggersourceparent.find('.continue-engrave').show();

          } else {
            $triggersourceparent.removeClass('sourceis-complete');
            $('.product-form__cart-submit').attr("disabled","disabled");
             $('.product-form__cart-submit').attr("title","You need to select a source first");

            /* Engrave Condition */
            $triggersourceparent.find('.continue-engrave').hide();
            $('.toggle-engrave').toggleClass('rotate');
            $('.toggle-engrave').hide();
            if ($triggersourceparent.hasClass('engrave')){
              $('.step-2-part-2').removeClass('not-disabled');
            }
          }
        });

        if ( $(this).hasClass('active-urgent') ) {
          $triggersourceparent.addClass('sourceis-complete');
          $triggersourceparent.find('.kit').hide();
          $triggersourceparent.find('.active_source').show();
          if ( condtionsource() == $howmanysource ) {
            $('.product-form__cart-submit').removeAttr("disabled");
            $('.product-form__cart-submit').attr("title","Add to cart");
          }

        }



      } else {
        $('.product-form__cart-submit').attr("disabled","disabled");
        
              $triggersourceparent.find('.source').show();
                $triggersourceparent.find('.kit').hide();
                $triggersourceparent.find('.xx').hide();

                $triggersourceparent.addClass('sourceis-complete');

			//console.log('no');
             

                /* Engrave Condition */
                $('.toggle-engrave').show();
                if ($triggersourceparent.hasClass('engrave')){
                  $('.step-2-part-2').addClass('not-disabled');
                }
                $triggersourceparent.find('.continue-engrave').hide();
                if ($triggersourceparent.hasClass('engrave')){
                  $triggersourceparent.slideUp('slow');
                }
        $('.product-form__cart-submit').attr("disabled","disabled");
        $('.product-form__cart-submit').attr("title","You need to select a source first");

        var dp_value = $triggersourceparent.find( "select.collectionkit-trigger-complete" ).val();
        console.log(dp_value);
          if ( dp_value != '' ) {
           // alert($(this).val());
        	   if ( condtionsource() == $howmanysource ) {
                  $('.product-form__cart-submit').removeAttr("disabled");
                 $('.product-form__cart-submit').attr("title","Add to cart");
                } else {
                  $('.product-form__cart-submit').attr("disabled","disabled");
                  $('.product-form__cart-submit').attr("title","You need to select a source first");
                }

          } else {
           	$('.product-form__cart-submit').attr("disabled","disabled");
            $('.product-form__cart-submit').attr("title","You need to select a source first");
            }
          
        
         $triggersourceparent.find( "select.collectionkit-trigger-complete" ).on('change',function() {
          if ( $(this).val() != '' ) {
           // alert($(this).val());
        	   if ( condtionsource() == $howmanysource ) {
                  $('.product-form__cart-submit').removeAttr("disabled");
                 $('.product-form__cart-submit').attr("title","Add to cart");
                } else {
                  $('.product-form__cart-submit').attr("disabled","disabled");
                  $('.product-form__cart-submit').attr("title","You need to select a source first");

                }

          } else {
           	$('.product-form__cart-submit').attr("disabled","disabled");
            $('.product-form__cart-submit').attr("title","You need to select a source first");

            }
          
        });
        
      
      }

    }
  });

  function condtionsource() {
    var x = 0;
    $('.sourceis-complete').each(function(){
        x++;
    });
    return x;
  }

  $('.back').click(function(event){
    event.preventDefault();
    if ($('.product-form__step-container').hasClass('is-active')) {
      var $current_parent = $(this).parents('.product-form__source');

      if ( $current_parent.hasClass('product_exist')) {
        $current_parent.find('.xx').show();
        $current_parent.find('.active_source').hide();
        $('.product-form__cart-submit').attr("disabled","disabled");
        $('.product-form__cart-submit').attr("title","You need to select a source first");
        $current_parent.find('.source').hide();
        $current_parent.find('.qq:not(.xx)').hide();
        $current_parent.removeClass('sourceis-complete');
      } else {
        $current_parent.find('.qq').show();
        $current_parent.find('.kit').hide();
        $current_parent.find('.xx').hide();
        $current_parent.find('.source').hide();
        $current_parent.removeClass('sourceis-complete');
        $('.product-form__cart-submit').attr("disabled","disabled");
        $('.product-form__cart-submit').attr("title","You need to select a source first");
        $('.toggle-engrave').hide();
        $('.toggle-engrave').removeClass('rotate');
        if ($current_parent.hasClass('engrave')){
          $('.step-2-part-2').removeClass('not-disabled');
        }
      }
    }
  });
  $('.continue-engrave').click(function(){
  $(this).parents('.product-form__source').slideUp('slow');
    $('.toggle-engrave').show();
    var $engrave_parent = $(this).parents('.product-form__source');
    if ($engrave_parent.hasClass('engrave')){
      $('.step-2-part-2').addClass('not-disabled');
    }
  });
  $('.toggle-engrave').click(function(){
    $('.engrave').slideToggle('slow');
    $('.toggle-engrave').toggleClass('rotate');
  });
   function bundle() {
      //Ajax request to add special item to cart
      jQuery.ajax({
        type: "POST",
        url: '/cart/add.js',
        data: {
          quantity: 1,
          //id: 4294001328222
          id: 29394642239582
        },
        async: false,
        success: function() {
          jQuery('.product-form__step-container[data-step="2"]').addClass('success_hide');
        }
      })

    };
  function pre_bundle($getsource) {

    var $data = {};

    $data['quantity'] = 1;
    $data['id'] = 30932687126622;
    $data['properties'] = $getsource;

    jQuery.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: $data,
      async: false,
      success: function() {
        jQuery('.product-form__step-container[data-step="2"]').addClass('success_hide');

      }
    })

  };


  function trigger_source() {
    $('.product-form__source').each(function(){
      if ($(this).hasClass('not-source')) {

      } else {
        var $source = $(this).data('source_ans');
        if ( $source == "No" ) {
          bundle();
        } else if ($source == "Yes") {
          var $source_name = $(this).data('sourcename');
          var $source_id = $(this).find('.collectionkit-trigger-complete').val();
          var $source_array = {};

          if($('#source_1').length == 0) {
            $(this).find('.product_activation').each(function(){
                $source_array[$(this).attr('name')] = $(this).val();
            });
          } else {
              $source_array[$source_name] = $source_id;
          }

          pre_bundle($source_array);
        }
      }


    });
    //Tattoo
    var $tattoo_selector = $('.product-form__source-container .js-product-variant-selector').val();
    var $tattoo_quan = $('.source_count.field input').val();
    if ( $tattoo_quan > 0 ) {
      jQuery.ajax({
        type: "POST",
        url: '/cart/add.js',
        data: {
          quantity: $tattoo_quan,
          //id: 4294001328222
          id: 31061138473054
        },
        async: false,
        success: function() {

        }
      })
    }
    //Engrave
    if ( $('.engrave')[0] ) {
      var $engrave_val = $('.engrave .collectionkit-trigger-complete').val();

      if ( $engrave_val != '' ) {
        jQuery.ajax({
          type: "POST",
          url: '/cart/add.js',
          data: {
            quantity: 1,
            id: 31155714261086,
            properties: {
            'Engrave': $engrave_val
            }
          },
          async: false,
          success: function() {
        window.location.href = "/cart"
          }
        });
      }
    }
  }
